import { all } from "redux-saga/effects";

import landingPageSagas from "./features/landingPage/redux/sagas";
import liveCommunicatorSagas from "./features/liveCommunicator/redux/sagas";
import vodCommunicatorSagas from "./features/vodCommunicator/redux/sagas";

export default function* rootSaga() {
    yield all([landingPageSagas(), liveCommunicatorSagas(), vodCommunicatorSagas()]);
}
